module.exports = __webpack_public_path__ + "img/186.ff0b61dc.gif";